export default "__VITE_ASSET__jRj5278D__"